import { Box, Divider, Typography } from "@mui/material";
import React from "react";

type SignatureGroupProps = {
  title: string;
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
};

const SignatureGroup = ({
  title,
  leftComponent,
  rightComponent,
}: SignatureGroupProps) => {
  return (
    <Box
      display={"flex"}
      flex={1}
      marginLeft={3}
      marginBottom={8}
      data-testid="signature-group"
    >
      <Box display={"flex"} flex={1} flexDirection={"column"}>
        <Typography variant={"h2"} marginRight={3}>
          {title}
        </Typography>
        {leftComponent && leftComponent}
      </Box>
      <Box>
        <Divider
          orientation={"vertical"}
          sx={{
            color: "black",
          }}
        />
      </Box>
      <Box display={"flex"} flex={2} marginLeft={3}>
        {rightComponent && rightComponent}
      </Box>
    </Box>
  );
};

export default SignatureGroup;
